<template>
<div class="nmain">
    <div class="img">
    </div>
    <div class="text">
        出了一点小问题，不妨稍后试试
    </div>
</div>
</template>

<style scoped>
.img {
    height: 190px;
    width: 190px;
    background-image: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/239ff77f5cc76954a1b8e1a1ea84f684.png);
    background-size: 100%;
}
.text {
    width: 348px;
    height: 33px;
    font-size: 24px;
    font-weight: 400;
    color: #9BA3AE;
    line-height: 33px;
}
.nmain {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 100%;
    width: 100%;
}
</style>